// AddCustomerspayment.js - Complete (GBP Constraint Removed)

import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaMoneyBill, FaArrowLeft, FaSave, FaClock, FaSearch } from 'react-icons/fa';
import { FaCircleArrowRight } from "react-icons/fa6";
import { FaCircleArrowLeft } from "react-icons/fa6";
import './Customerspayment.css';

const AddCustomerspayment = () => {
  const navigate = useNavigate();

  // Form fields
  const [account, setAccount] = useState('');
  const [paymentDate, setPaymentDate] = useState('');
  const [reference, setReference] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');

  // ✅ NEW: City & Shop fields
  const [city, setCity] = useState('');
  const [cities, setCities] = useState([]);
  const [shops, setShops] = useState([]);
  const [selectedShopId, setSelectedShopId] = useState('');
  const [selectedShopName, setSelectedShopName] = useState('');
  const [loadingCities, setLoadingCities] = useState(false);

  // Invoice Data (Mock data - aap real API se bhi fetch kar sakti hain)
  const allInvoices = [
    { id: 1, invoiceNumber: 'INV0092', orderNumber: 'HT00092', displayText: 'Invoice #INV0092 for Order HT00092' },
    { id: 2, invoiceNumber: 'INV0091', orderNumber: 'HT00091', displayText: 'Invoice #INV0091 for Order HT00091' },
    { id: 3, invoiceNumber: 'INV0090', orderNumber: 'HT00090', displayText: 'Invoice #INV0090 for Order HT00090' },
    { id: 4, invoiceNumber: 'INV0060', orderNumber: 'HT00060', displayText: 'Invoice #INV0060 for Order HT00060' },
    { id: 5, invoiceNumber: 'INV0061', orderNumber: 'HT00061', displayText: 'Invoice #INV0061 for Order HT00061' },
    { id: 6, invoiceNumber: 'INV0062', orderNumber: 'HT00062', displayText: 'Invoice #INV0062 for Order HT00062' },
    { id: 7, invoiceNumber: 'INV0118', orderNumber: 'HT00118', displayText: 'Invoice #INV0118 for Order HT00118' },
    { id: 8, invoiceNumber: 'INV0125', orderNumber: 'Ht00125', displayText: 'Invoice #INV0125 for Order Ht00125' },
    { id: 9, invoiceNumber: 'INV0126', orderNumber: 'HT00126', displayText: 'Invoice #INV0126 for Order HT00126' },
    { id: 10, invoiceNumber: 'INV0127', orderNumber: 'HT00127', displayText: 'Invoice #INV0127 for Order HT00127' },
    { id: 11, invoiceNumber: 'INV0128', orderNumber: 'HT00128', displayText: 'Invoice #INV0128 for Order HT00128' },
  ];

  // State for available and chosen invoices
  const [availableInvoices, setAvailableInvoices] = useState(allInvoices);
  const [chosenInvoices, setChosenInvoices] = useState([]);
  const [selectedAvailable, setSelectedAvailable] = useState([]);
  const [selectedChosen, setSelectedChosen] = useState([]);

  // Search terms
  const [availableSearchTerm, setAvailableSearchTerm] = useState('');
  const [chosenSearchTerm, setChosenSearchTerm] = useState('');

  // Dropdown visibility
  const [showAvailableDropdown, setShowAvailableDropdown] = useState(true);

  // Refs
  const availableDropdownRef = useRef(null);

  // Timestamp fields
  const [createdAt, setCreatedAt] = useState('');
  const [updatedAt, setUpdatedAt] = useState('');

  // API Base URL
  const API_BASE_URL = 'https://super-backend.hira-tech.co.uk';

  // Helper function to get auth token
  const getAuthToken = () => {
    const token = localStorage.getItem('access_token') || localStorage.getItem('token') || localStorage.getItem('accessToken');
    if (token) return token;
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    return userData?.access_token || userData?.token || null;
  };

  // Helper function for API calls
  const apiFetch = async (url, options = {}) => {
    const token = getAuthToken();
    const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}${url}`;
    const headers = { 'Content-Type': 'application/json', ...options.headers };

    if (token) { headers['Authorization'] = `Bearer ${token}`; }

    const response = await fetch(fullUrl, { ...options, headers });

    if (!response.ok) {
      let errorMessage = `API error: ${response.status} ${response.statusText}`;
      try {
        const errorData = await response.json();
        if (errorData.error) { errorMessage = errorData.error; }
        else if (errorData.message) { errorMessage = errorData.message; }
      } catch (e) {}
      throw new Error(errorMessage);
    }

    return response.json();
  };

  // ============== FETCH SHOPS ==============
  const fetchShops = async () => {
    try {
      const data = await apiFetch('/user/shops/');
      let shopsData = [];
      if (data.results) shopsData = data.results;
      else if (Array.isArray(data)) shopsData = data;
      else if (data.shops) shopsData = data.shops;
      setShops(shopsData);

      if (shopsData.length > 0) {
        setSelectedShopId(shopsData[0].shop_id);
        setSelectedShopName(shopsData[0].shop_name);
      }
    } catch (error) {
      console.error('Error fetching shops:', error);
    }
  };

  // ============== FETCH CITIES ==============
  const fetchCities = async (shopId) => {
    if (!shopId) {
      setCities([]);
      return;
    }

    try {
      setLoadingCities(true);
      const data = await apiFetch(`/order/shop-cities/?shop_id=${shopId}`);
      if (data && data.cities) {
        setCities(data.cities);
      } else {
        setCities([]);
      }
    } catch (error) {
      console.error('Error fetching cities:', error);
      setCities([]);
    } finally {
      setLoadingCities(false);
    }
  };

  // ============== LOAD DATA ON MOUNT ==============
  useEffect(() => {
    fetchShops();
  }, []);

  // ============== LOAD CITIES WHEN SHOP CHANGES ==============
  useEffect(() => {
    if (selectedShopId) {
      fetchCities(selectedShopId);
    } else {
      setCities([]);
    }
  }, [selectedShopId]);

  // Filter available invoices based on search term
  const filteredAvailableInvoices = availableInvoices.filter(invoice =>
    invoice.displayText.toLowerCase().includes(availableSearchTerm.toLowerCase())
  );

  // Filter chosen invoices based on search term
  const filteredChosenInvoices = chosenInvoices.filter(invoice =>
    invoice.displayText.toLowerCase().includes(chosenSearchTerm.toLowerCase())
  );

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (availableDropdownRef.current && !availableDropdownRef.current.contains(event.target)) {
        setShowAvailableDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Show dropdown when focusing on search
  const handleSearchFocus = () => {
    setShowAvailableDropdown(true);
  };

  // Handle select/deselect available invoice
  const handleSelectAvailable = (invoiceId) => {
    setSelectedAvailable(prev =>
      prev.includes(invoiceId)
        ? prev.filter(id => id !== invoiceId)
        : [...prev, invoiceId]
    );
  };

  // Move selected invoices from available to chosen
  const moveToChosen = () => {
    if (selectedAvailable.length === 0) return;

    const selectedInvoices = availableInvoices.filter(invoice => selectedAvailable.includes(invoice.id));
    setChosenInvoices([...chosenInvoices, ...selectedInvoices]);
    setAvailableInvoices(availableInvoices.filter(invoice => !selectedAvailable.includes(invoice.id)));
    setSelectedAvailable([]);

    // Set timestamps when invoices are added
    const now = new Date().toLocaleString();
    if (createdAt === '') {
      setCreatedAt(now);
    }
    setUpdatedAt(now);
  };

  // Remove selected invoices from chosen
  const removeFromChosen = () => {
    if (selectedChosen.length === 0) return;

    const selectedInvoices = chosenInvoices.filter(invoice => selectedChosen.includes(invoice.id));
    setAvailableInvoices([...availableInvoices, ...selectedInvoices]);
    setChosenInvoices(chosenInvoices.filter(invoice => !selectedChosen.includes(invoice.id)));
    setSelectedChosen([]);

    // Update timestamp when removing
    const now = new Date().toLocaleString();
    setUpdatedAt(now);
  };

  // Handle select/deselect chosen invoice
  const handleSelectChosen = (invoiceId) => {
    setSelectedChosen(prev =>
      prev.includes(invoiceId)
        ? prev.filter(id => id !== invoiceId)
        : [...prev, invoiceId]
    );
  };

  // Select all available invoices
  const selectAllAvailable = () => {
    const allIds = filteredAvailableInvoices.map(inv => inv.id);
    setSelectedAvailable(allIds);
  };

  // Select all chosen invoices
  const selectAllChosen = () => {
    const allIds = filteredChosenInvoices.map(inv => inv.id);
    setSelectedChosen(allIds);
  };

  // Handle shop change
  const handleShopChange = (e) => {
    const shopId = e.target.value;
    const shop = shops.find(s => String(s.shop_id) === String(shopId));
    setSelectedShopId(shopId);
    setSelectedShopName(shop ? shop.shop_name : '');
    setCity(''); // Reset city when shop changes
  };

  const handleSave = async () => {
    // Validation
    if (account.trim() === '') {
      alert('Please enter account name');
      return;
    }
    if (paymentDate.trim() === '') {
      alert('Please select payment date');
      return;
    }
    if (reference.trim() === '') {
      alert('Please enter reference');
      return;
    }
    if (paymentMethod.trim() === '') {
      alert('Please select payment method');
      return;
    }
    if (!selectedShopId) {
      alert('Please select a shop');
      return;
    }
    if (chosenInvoices.length === 0) {
      alert('Please select at least one invoice');
      return;
    }

    // Prepare payment data
    const paymentData = {
      shop_id: parseInt(selectedShopId),
      account: account.trim(),
      payment_date: paymentDate,
      reference_number: reference.trim(),
      payment_method: paymentMethod,
      city: city || null,
      invoice_ids: chosenInvoices.map(inv => inv.invoiceNumber)
    };

    console.log('Saving payment:', paymentData);

    try {
      // Call API to save payment
      const response = await apiFetch('/order/api/customer-payments/', {
        method: 'POST',
        body: JSON.stringify(paymentData)
      });

      alert('Payment added successfully!');
      navigate('/Customerspayment');
    } catch (error) {
      console.error('Error saving payment:', error);
      alert('Failed to save payment: ' + error.message);
    }
  };

  const handleCancel = () => {
    navigate('/Customerspayment');
  };

  return (
    <div className="add-payment-main-container">
      {/* Header Section */}
      <div className="add-payment-header-section">
        <div className="header-content">
          <button className="back-btn" onClick={handleCancel}>
            <FaArrowLeft />
          </button>
          <FaMoneyBill className="header-icon" />
          <h2>Add Customer Payment</h2>
        </div>
        <p className="header-subtitle">Create new customer payment record</p>
      </div>

      <div className="add-payment-content">
        <form className="add-payment-form">

          {/* ✅ NEW: Shop Selection Field (Icon Removed) */}
          <div className="form-group">
            <label>
              SHOP *
            </label>
            <select
              value={selectedShopId}
              onChange={handleShopChange}
              className="form-select"
            >
              <option value="">Select Shop</option>
              {shops.map((shop) => (
                <option key={shop.shop_id} value={shop.shop_id}>
                  {shop.shop_name} ({shop.full_domain || shop.subdomain})
                </option>
              ))}
            </select>
            {selectedShopName && (
              <small className="field-hint" style={{ color: '#004aad', fontWeight: '500' }}>
                Selected: {selectedShopName}
              </small>
            )}
          </div>

          {/* ✅ NEW: City Field (Simple Dropdown, Icon Removed) */}
          <div className="form-group">
            <label>
              CITY:
            </label>
            <select
              value={city}
              onChange={(e) => setCity(e.target.value)}
              className="form-select"
              disabled={loadingCities || cities.length === 0 || !selectedShopId}
            >
              <option value="">Select City</option>
              {cities.map((cityName, index) => (
                <option key={index} value={cityName}>
                  {cityName}
                </option>
              ))}
            </select>
            {loadingCities && (
              <small className="field-hint" style={{ color: '#999' }}>
                Loading cities...
              </small>
            )}
            {!selectedShopId && (
              <small className="field-hint" style={{ color: '#999' }}>
                Please select a shop first to load cities
              </small>
            )}
            {selectedShopId && cities.length === 0 && !loadingCities && (
              <small className="field-hint" style={{ color: '#999' }}>
                No cities available for this shop. Please add cities in shop settings.
              </small>
            )}
          </div>

          {/* Account Field */}
          <div className="form-group">
            <label>Account *</label>
            <input
              type="text"
              value={account}
              onChange={(e) => setAccount(e.target.value)}
              placeholder="Enter account name"
              autoFocus
            />
          </div>

          {/* Payment Date Field */}
          <div className="form-group">
            <label>Payment Date *</label>
            <input
              type="date"
              value={paymentDate}
              onChange={(e) => setPaymentDate(e.target.value)}
            />
          </div>

          {/* Reference Field */}
          <div className="form-group">
            <label>Reference *</label>
            <input
              type="text"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              placeholder="Enter reference number"
            />
          </div>

          {/* Payment Method Field */}
          <div className="form-group">
            <label>Payment Method *</label>
            <select
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
              className="payment-method-select"
            >
              <option value="">Select Payment Method</option>
              <option value="Cash">Cash</option>
              <option value="Bank Transfer">Bank Transfer</option>
              <option value="Credit Card">Credit Card</option>
              <option value="Debit Card">Debit Card</option>
              <option value="Check">Check</option>
              <option value="Online Payment">Online Payment</option>
              <option value="Mobile Payment">Mobile Payment</option>
            </select>
          </div>

          {/* Related Invoices Section */}
          <div className="related-invoices-section">
            <h3 className="related-invoices-title">Related Invoices</h3>

            <div className="invoices-simple-container">
              {/* Available Invoices with Dropdown */}
              <div className="available-invoices-section" ref={availableDropdownRef}>
                <div className="section-header">
                  <h4>Available Invoices</h4>
                </div>

                {/* Search Input */}
                <div className="invoice-search-wrapper">
                  <div className="invoice-search-input-wrapper">
                    <FaSearch className="search-icon-dropdown" />
                    <input
                      type="text"
                      placeholder="Filter invoices..."
                      value={availableSearchTerm}
                      onChange={(e) => setAvailableSearchTerm(e.target.value)}
                      onFocus={handleSearchFocus}
                      className="invoice-search-field"
                    />
                  </div>

                  {/* Dropdown - Always visible below search */}
                  {showAvailableDropdown && (
                    <div className="invoice-dropdown-list">
                      {filteredAvailableInvoices.length === 0 ? (
                        <div className="dropdown-empty">
                          {availableSearchTerm ? `No invoices found for "${availableSearchTerm}"` : 'No invoices available'}
                        </div>
                      ) : (
                        <>
                          {/* Select All option */}
                          <div className="dropdown-item select-all-item" onClick={selectAllAvailable}>
                            <input
                              type="checkbox"
                              checked={selectedAvailable.length === filteredAvailableInvoices.length && filteredAvailableInvoices.length > 0}
                              onChange={() => {}}
                              onClick={(e) => e.stopPropagation()}
                            />
                            <span className="select-all-text">Select All ({filteredAvailableInvoices.length})</span>
                          </div>
                          <div className="dropdown-divider"></div>
                          {filteredAvailableInvoices.map((invoice) => (
                            <div
                              key={invoice.id}
                              className={`dropdown-item ${selectedAvailable.includes(invoice.id) ? 'selected' : ''}`}
                              onClick={() => handleSelectAvailable(invoice.id)}
                            >
                              <input
                                type="checkbox"
                                checked={selectedAvailable.includes(invoice.id)}
                                onChange={() => {}}
                                onClick={(e) => e.stopPropagation()}
                              />
                              <span>{invoice.displayText}</span>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  )}
                </div>

                {/* Selected Count Display */}
                {selectedAvailable.length > 0 && (
                  <div className="selected-count-badge">
                    {selectedAvailable.length} invoice(s) selected
                  </div>
                )}
              </div>

              {/* Arrow Buttons */}
              <div className="simple-arrows-column">
                <button
                  type="button"
                  className="arrow-btn add-btn"
                  onClick={moveToChosen}
                  disabled={selectedAvailable.length === 0}
                  title="Add selected invoices"
                >
                  <FaCircleArrowRight className="arrow-icon" />
                </button>
                <button
                  type="button"
                  className="arrow-btn remove-btn"
                  onClick={removeFromChosen}
                  disabled={selectedChosen.length === 0}
                  title="Remove selected invoices"
                >
                  <FaCircleArrowLeft className="arrow-icon" />
                </button>
              </div>

              {/* Chosen Invoices Section */}
              <div className="chosen-invoices-section">
                <div className="section-header">
                  <h4>CHOSEN INVOICES</h4>
                </div>

                {/* Search Input - Text only */}
                <div className="chosen-search-wrapper">
                  <FaSearch className="search-icon-chosen" />
                  <input
                    type="text"
                    placeholder="Search in chosen invoices..."
                    value={chosenSearchTerm}
                    onChange={(e) => setChosenSearchTerm(e.target.value)}
                    className="chosen-search-field"
                  />
                </div>

                {/* Chosen Invoices List */}
                <div className="chosen-list-container">
                  {filteredChosenInvoices.length === 0 ? (
                    <div className=""></div>
                  ) : (
                    <>
                      {/* Select All option for chosen */}
                      <div className="chosen-item select-all-chosen" onClick={selectAllChosen}>
                        <input
                          type="checkbox"
                          checked={selectedChosen.length === filteredChosenInvoices.length && filteredChosenInvoices.length > 0}
                          onChange={() => {}}
                          onClick={(e) => e.stopPropagation()}
                        />
                        <span className="select-all-text">Select All ({filteredChosenInvoices.length})</span>
                      </div>
                      <div className="dropdown-divider"></div>
                      {filteredChosenInvoices.map((invoice) => (
                        <div
                          key={invoice.id}
                          className={`chosen-item ${selectedChosen.includes(invoice.id) ? 'selected' : ''}`}
                          onClick={() => handleSelectChosen(invoice.id)}
                        >
                          <input
                            type="checkbox"
                            checked={selectedChosen.includes(invoice.id)}
                            onChange={() => {}}
                            onClick={(e) => e.stopPropagation()}
                          />
                          <span>{invoice.displayText}</span>
                        </div>
                      ))}
                    </>
                  )}
                </div>

                {/* Selected Count Display */}
                {selectedChosen.length > 0 && (
                  <div className="selected-count-badge">
                    {selectedChosen.length} invoice(s) selected
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Timestamp Fields */}
          <div className="timestamp-section">
            <div className="timestamp-header">
              <FaClock className="timestamp-icon" />
              <span>Timestamps</span>
            </div>

            <table className="timestamp-table">
              <tbody>
                <tr>
                  <td className="timestamp-label">Created at:</td>
                  <td className="timestamp-value">
                    {createdAt || '-'}
                  </td>
                </tr>
                <tr>
                  <td className="timestamp-label">Updated at:</td>
                  <td className="timestamp-value">
                    {updatedAt || '-'}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Form Actions */}
          <div className="form-actions">
            <button type="button" className="btn-cancel" onClick={handleCancel}>
              Cancel
            </button>
            <button type="button" className="btn-save" onClick={handleSave}>
              <FaSave /> Save Payment
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCustomerspayment;